/**
 * Get the top offset for the mobile navigation modal
 * This is used to position the mobile navigation modal correctly
 *
 * @returns {string} The top offset in pixels
 */
function getHeaderHeight() {
    // Calculate nano banner(s) height
    const nanoBannersEls = document.querySelectorAll('.nano-banner-element');
    const nanoBannerHeight = Array.from(nanoBannersEls).reduce((sum, element) => sum + element.offsetHeight, 0);

    // Get site header height
    const siteHeaderEl = document.getElementById('site-header');
    const siteHeaderHeight = siteHeaderEl?.offsetHeight || 0;

    return `${nanoBannerHeight + siteHeaderHeight}px`;
}

export { getHeaderHeight };
